import React from 'react';
import classNames from 'classnames';
import { EventSource } from '@/shared/constants/event';
import { logCommonView } from '@/lib/service';
import './index.less';

interface IProps {
  sorts: string;
  sortOptions: { label: string; value: string }[];
  applySort: (value: string) => void;
}

const MarketplaceSortTabs = ({ sorts, sortOptions, applySort }: IProps) => {
  const handleClickOption = (value: string) => {
    applySort(value);
    logCommonView(EventSource.BROWSE_SUPPLIER_SORT_RESULTS_FILTER_TAB, value);
  };

  return (
    <div className="marketplace-sort-tabs">
      {sortOptions.map((option: { label: string; value: string }) => (
        <div
          className={classNames('sort-tab', { active: sorts === option.value })}
          key={option.value}
          onClick={() => handleClickOption(option.value)}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
};

export default MarketplaceSortTabs;
